import { useCallback } from 'react';
import { useReleasePresaveCampaignMutation } from '../../../redux/api/fymAPI';
import { isSuccessfulResult } from '../../../redux/api/utils/isSuccessfulResult';

interface UseReleaseCampaignProps {
  accountId: number;
  campaignId: number;
  /** Passed through so the panel's cache entry, keyed by uuid, is dropped too. */
  campaignUuid?: string;
  smartLinkId: number;
}

/**
 * Marks a campaign released. The server identifies every url, rewrites the
 * page and queues the saves, so a rejected url means nothing happened at all —
 * the artist can correct it and try again.
 */
export function useReleaseCampaign({ accountId, campaignId, campaignUuid, smartLinkId }: UseReleaseCampaignProps) {
  const [releasePresaveCampaign, { isLoading, error, reset }] = useReleasePresaveCampaignMutation();

  const release = useCallback(
    async (urls: string[]): Promise<boolean> => {
      const result = await releasePresaveCampaign({ accountId, campaignId, campaignUuid, smartLinkId, urls });
      return isSuccessfulResult(result);
    },
    [accountId, campaignId, campaignUuid, releasePresaveCampaign, smartLinkId]
  );

  return { release, isLoading, error, reset };
}
